import { useState } from 'react';

export default function useFilters(defaultFilters) {
  const [activeFilter, setActiveFilter] = useState('');
  const [unsavedFilters, setUnsavedFilters] = useState({ ...defaultFilters });
  const [savedFilters, setSavedFilters] = useState({ ...defaultFilters });

  function handleFilterChange(filterType, value, shouldAutomaticallySaveState = false) {
    if (shouldAutomaticallySaveState) {
      setSavedFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    } else {
      setUnsavedFilters((prev) => ({ ...prev, [filterType]: value }));
    }
  }

  function handleFilterSaveClick(filterType) {
    setSavedFilters((prev) => ({
      ...prev,
      [filterType]: unsavedFilters[filterType],
    }));
    setActiveFilter('');
  }

  function handleFilterToggleClick(filterType) {
    if (activeFilter === filterType) {
      setActiveFilter('');
    } else {
      setActiveFilter(filterType);
    }
  }

  function handleFilterCloseClick(filterType) {
    setUnsavedFilters((prev) => ({
      ...prev,
      [filterType]: savedFilters[filterType],
    }));
    setActiveFilter('');
  }

  function setUnsavedAndSavedFilter(filterType, value) {
    handleFilterChange(filterType, value);
    handleFilterChange(filterType, value, true);
  }

  return {
    handleFilterChange,
    handleFilterToggleClick,
    handleFilterCloseClick,
    handleFilterSaveClick,
    setUnsavedAndSavedFilter,
    unsavedFilters,
    savedFilters,
    activeFilter,
  };
}
